export function DrillDownModal({ title, data, onClose }) {
  if (!data) return null;

  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center">
      <div className="w-full max-w-3xl rounded-2xl bg-[#0f0f0f] border border-white/10">

        <div className="flex justify-between items-center px-6 py-4 border-b border-white/10">
          <h3 className="font-serif">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            ✕
          </button>
        </div>

        <div className="p-6">
          <table className="w-full text-sm">
            <thead className="text-gray-400">
              <tr>
                <th className="text-left py-2">Item</th>
                <th className="text-right py-2">Revenue</th>
                <th className="text-right py-2">Cost</th>
                <th className="text-right py-2">Profit</th>
              </tr>
            </thead>
            <tbody>
              {data.map((d, i) => (
                <tr key={i} className="border-t border-white/10">
                  <td className="py-2">{d.item}</td>
                  <td className="py-2 text-right">₹{d.revenue}</td>
                  <td className="py-2 text-right text-rose-400">₹{d.cost}</td>
                  <td className="py-2 text-right text-emerald-400">
                    ₹{d.revenue - d.cost}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}
